// Source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/en.xml#L1847
module["exports"] = {
  wide: ["شنبه", "یکشنبه", "دوشنبه", "سه شنبه", "چهارشنبه", "پتچشنبه", "جمعه"],
  wide_context: ["شنبه", "یکشنبه", "دوشنبه", "سه شنبه", "چهارشنبه", "پتچشنبه", "جمعه"],
  abbr: ["ش", "ی", "د", "س", "چ", "پ", "ج"],
  abbr_context: ["ش", "ی", "د", "س", "چ", "پ", "ج"]
};